import { Box, Paper, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { React, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ProgressBar from "./ProgressBar";
import { setState } from "../dashBoardSlice";

export default function RunningPeriodStatus() {
	const state = useSelector((store) => store.dashboard);
	const dispatch = useDispatch();
	const { isLoading, drawerOpen, scenarios } = state;

	const columns = [
		{
			field: "scenarioName",
			headerName: "Scenario Name",
			flex: 2,
		},
		{
			field: "quota",
			headerName: "Quota",
			flex: 1,
			valueFormatter: (params) => {
				const formattedValue = Number(params.value)?.toLocaleString('en-US');
				return formattedValue;
			},
		},
		{
			field: "efs",
			headerName: "Quota Consumption",
			flex: 2,
			renderCell: (cellValues) => {
				let progressBarValue = 0;
				if (cellValues.row.quota === 0.0) {
					progressBarValue = 0;
				} else {
					progressBarValue = (
						(cellValues.row.efs / cellValues.row.quota) *
						100
					).toFixed();
				}
				let progressBarColor = "#B6D0E2";
				return (
					<Box
						sx={{
							width: "100%",
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<ProgressBar
							//bgcolor="#007bff"
							progress={progressBarValue}
							progressContent={cellValues.row.consumption?.toLocaleString('en-US')}
							height={30}
							bgcolor={progressBarColor}
						/>

						<label style={{ marginLeft: "10px" }}>
							{progressBarValue + "%"}
						</label>
					</Box>
				);
			},
		},
	];

	useEffect(() => {
		
    // commented below lines because new requirement
    // new requirement: if user clicked on approval stat links to go to a page (analyze, approval, etc)
    // and then comes back to dashboard from those pages then data should not clear in dashboard 
    // dispatch(setState("scenarios", []));
		// dispatch(
		// 	setState("approvalStats", {
		// 		scenarioCount: 0,
		// 		quotaCount: 0,
		// 		quotaModificationsCount: 0,
		// 	})
		// );
	}, []);

	return (
		<>
			{scenarios.length > 0 && !isLoading ? (
				<Paper
					elevation={0}
					sx={{
						width: drawerOpen ? "75%" : "100%",
						borderRadius: 2,
						paddingTop: 0,
					}}
				>
					<Typography
						variant="subtitle1"
						gutterBottom
						sx={{ color: "#000000" }}
					>
						Running Period Status
					</Typography>

					<DataGrid
						style={{ maxHeight: "calc(100vh - 130px)" }}
						disableColumnMenu
						sx={{
							"& .MuiDataGrid-columnHeaderTitle": {
								whiteSpace: "normal",
								lineHeight: "normal",
							},
							"& .MuiDataGrid-columnHeader": {
								position: "sticky",
							},
							"& .MuiDataGrid-columnHeaders": {
								maxHeight: "168px !important",
							},
							"& .MuiDataGrid-columnHeader[data-field='orderStatus']": {
								paddingLeft: "20px", // Apply specific padding to the 'Order Status' header
							},
						}}
						rowHeight={70}
						rows={scenarios || []}
						columns={columns}
						getRowId={(scenarios) => scenarios?.scenarioID}
						initialState={{
							pagination: {
								paginationModel: {
									pageSize: 20,
								},
							},
						}}
						pageSizeOptions={[20, 50, 100]}
						disableRowSelectionOnClick
					/>
				</Paper>
			) : (
				<Paper
					elevation={0}
					sx={{
						width: drawerOpen ? "75%" : "100%",
						borderRadius: 2,
						paddingTop: 0,
						visibility: isLoading ? "hidden" : "visible",
					}}
				>
					<Typography variant="subtitle1" sx={{ color: "#000000", mt: 1 }}>
						Running Period Status
					</Typography>
					<DataGrid
						sx={{
							height: "300px",
							mt: 1,
							visibility: isLoading ? "hidden" : "visible",
						}}
						rows={[]}
						columns={columns}
						initialState={{
							pagination: {
								paginationModel: {
									pageSize: 20,
								},
							},
						}}
						disableColumnMenu
						pageSizeOptions={[20, 50, 100]}
						disableRowSelectionOnClick
					/>
				</Paper>
			)}
		</>
	);
}
